module.exports = __webpack_public_path__ + "img/order_null.b24ca565.png";